import { css } from "styled-components";
import { BladeContent } from "../../../../components/BladeContent";
export const riotProductSkin = (chroma) => css `
  padding-top: ${chroma.spacers.bladeEdge.top};

  ${BladeContent} {
    padding-bottom: ${chroma.spacers.variable.l};
  }
`;
//# sourceMappingURL=index.js.map